import mitt from 'mitt'

interface User {
  name: string
}
type ApplicationEvents = {
  'user:registered': User
  'user:deleted': User
  'data:update': Payload
};

export default defineNuxtPlugin(() => {
  // Then we just inform mitt about our event types
  const emitter = mitt<ApplicationEvents>()
  return {
    provide: {
      event: emitter.emit, // Will emit an event
      listen: emitter.on // Will register a listener for an event
    }
  }
})